var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M.71.71l7.67 7.67L16 .71","fill":"none","stroke":"#d5651b","strokeWidth":"2","data-name":"Layer 1"})));
}

ChevronDown.defaultProps = {"viewBox":"0 0 16.75 9.79"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
